import React, {useState, useEffect} from 'react'
import Loading from '../util/Loading'
import axios from 'axios'
import { API } from '../../Backend'

const VerifyPayment = ({verifyDetails}) => {

    const [loading, setLoading] = useState(true)
    const [success, setsuccess] = useState(true)

    const config = {
        headers: {
            "Content-type": 'application/json',
            Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        withCredentials: true
      }

      const verifyPayment = async () => {
          try {
            const {data} = await axios.post(`${API}/payments/verifyandupdate`, verifyDetails , config)
            return data 
          } catch (error) {
            console.log(error)
          }
      }

      useEffect(() => {
        verifyPayment()
        .then(res=>{
            console.log(res)
            if (res.success) {
                setLoading(false)
                setsuccess(true)
            } else {
                console.log(res)
            }
        })
      }, [])

      

  return (
    <div className='bg-white position-fixed d-flex align-items-center justify-content-center text-dark' style={{minHeight:"100vh", width:"100vw", zIndex:1000, top:0, left:0}}>
        {loading ? <Loading/> : {success} ? 
        <div className="col-12 text-center flex-column d-flex justify-content-center align-items-center" style={{minHeight:"50vh"}}>
            <div className="mb-7 font-size-h1">❤️</div>
            <h2 className="mb-5">Your payment is successful!</h2>
            {/* <p className="mb-7 text-gray-500">Your order has successfully placed. View detils on your dashboard.</p> */}
            <a className="btn btn-dark" href="/user/myorders">View Order Details</a>
        </div>
        : <p className='text-danger'>Payment could not be verified</p>}
    </div>
  )
}

export default VerifyPayment